import * as Portal from '@radix-ui/react-portal';

import { SidebarTrigger } from '../ui/sidebar';
import { useAppHeader } from './hooks';

export const AppHeader = () => {
  const { setActionContainer, setTitleContainer } = useAppHeader();
  return (
    <header className="flex h-10 mt-5 mb-0 px-6 shrink-0 items-center justify-between gap-2 transition-[width,height] ease-linear group-has-[[data-collapsible=icon]]/sidebar-wrapper:h-10">
      <div className="flex items-center">
        <SidebarTrigger className="size-4" />

        <div
          className="ml-4"
          ref={(ref) => {
            setTitleContainer(ref);
          }}
        />
      </div>
      <div
        className="flex gap-2 align-center"
        ref={(ref) => {
          setActionContainer(ref);
        }}
      />
    </header>
  );
};
AppHeader.displayName = 'AppHeader';

export const AppTitle = ({ children }: { children: React.ReactNode }) => {
  const { titleContainer } = useAppHeader();
  if (!titleContainer) return null;
  return <Portal.Root container={titleContainer}>{children}</Portal.Root>;
};

export const AppTitleText = ({ children }: { children: React.ReactNode }) => {
  return <h1 className="inline ml-2 text-foreground">{children}</h1>;
};

export const AppActions = ({ children }: { children: React.ReactNode }) => {
  const { actionContainer } = useAppHeader();
  if (!actionContainer) return null;
  return <Portal.Root container={actionContainer}>{children}</Portal.Root>;
};
